import styled from 'react-emotion'

const TabCount = styled('span')(({ active }) => ({
    fontFamily: 'Montserrat, sans-serif',
    color: active ? '#fff' : '#333',
    fontWeight: 700,
    fontSize: 36,
    marginBottom: 5,
    '@media (max-width: 500px)': {
        fontSize: 24
    }
}))

export default TabCount


// WEBPACK FOOTER //
// ./src/components/TabCountComponent.jsx